module.exports = "\n\n#impressumContainer {\n  margin-top: 20px;\n  padding-bottom: 20px;\n}\n"